// types
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { ConfigProps } from 'types/config';

export const BASE_PATH = '';

export const DASHBOARD_PATH = '/net';

const odevConfig = window.odevConfig;

const location = window.location;
const hostName: string = `${location.protocol}//${location.host}`;

// Environment variables or config values
const clientId: string = odevConfig?.IdentityServerClientId || process.env.REACT_APP_IDENTITY_CLIENT_ID || '';
const authUrl: string = odevConfig?.IdentityServerUrl || process.env.REACT_APP_IDENTITY_SERVER_URL || '';
const serviceBaseUrl: string = odevConfig?.AppServiceBaseUrl || process.env.REACT_APP_SERVICE_BASE_URL || '';

// Power BI configuration
const powerBiReportId: string = odevConfig?.PowerBiReportId || process.env.REACT_APP_POWER_BI_REPORT_ID || '';
const powerBiWorkspaceId: string = odevConfig?.powerBiWorkspaceId || process.env.REACT_APP_POWER_BI_WORKSPACE_ID || '';

// Grafana configuration
const grafanaUrl: string = odevConfig?.GrafanaUrl || process.env.REACT_APP_GRAFANA_URL || '';
const grafanaDashboardId: string = odevConfig?.GrafanaDashboardId || process.env.REACT_APP_GRAFANA_DASHBOARD_ID || '';
const grafanaHomeDashboard: string = odevConfig?.GrafanaHomeDashboard || process.env.REACT_APP_GRAFANA_HOME_DASHBOARD || '';

const appVersion: string = odevConfig?.AppVersion || process.env.REACT_APP_VERSION || '';
const swVersion: string = odevConfig?.SWVersion || process.env.REACT_APP_SW_VERSION || '';

const userManagerConfig: UserManagerSettings = {
    client_id: clientId,
    response_type: 'token id_token',
    scope: 'openid profile email',

    authority: authUrl,
    redirect_uri: `${hostName}/#/callback`,
    silent_redirect_uri: `${hostName}/#/silentRenew`,

    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: true,
    userStore: new WebStorageStateStore({ store: localStorage })
};

if (!authUrl) throw new Error("Missing env REACT_APP_IDENTITY_SERVER_URL or config value 'IdentityServerUrl'");
if (!serviceBaseUrl) throw new Error("Missing env REACT_APP_SERVICE_BASE_URL or config value 'AppServiceBaseUrl'");
if (!clientId) throw new Error("Missing env REACT_APP_IDENTITY_CLIENT_ID or config value 'IdentityServerClientId'");

if (!powerBiReportId) throw new Error("Missing env REACT_APP_POWER_BI_APPLICATION_ID or config value 'PowerBiApplicationId'");
if (!powerBiWorkspaceId) throw new Error("Missing env REACT_APP_POWER_BI_WORKSPACE_ID or config value 'PowerBiWorkspaceId'");

if (!grafanaUrl) throw new Error("Missing env REACT_APP_GRAFANA_URL or config value 'GrafanaUrl'");
if (!grafanaDashboardId) throw new Error("Missing env REACT_APP_GRAFANA_DASHBOARD_ID or config value 'GrafanaDashboardId'");
if (!grafanaHomeDashboard) throw new Error("Missing env REACT_APP_GRAFANA_DASHBOARD_NAME or config value 'GrafanaHomeDashboard'");

if (!appVersion) throw new Error("Missing env REACT_APP_VERSION or config value 'appVersion'");
if (!swVersion) throw new Error("Missing env REACT_APP_SW_VERSION or config value 'SWVersion'");

const config: ConfigProps = {
    navType: 'light', // light, dark
    locale: 'it', // 'it' - Italian
    appVersion,
    swVersion,
    userManagerConfig,
    serviceBaseUrl,
    powerBiConfig: {
        reportId: powerBiReportId,
        workspaceId: powerBiWorkspaceId
    },
    grafanaConfig: {
        url: grafanaUrl,
        dashboardId: grafanaDashboardId,
        homeDashboard: grafanaHomeDashboard
    }
};

export default config;
